class GhostTileController {
    constructor(breakpointsService) {
        this.breakpointsService = breakpointsService;
    }
}

GhostTileController.$inject = ['BreakpointsService'];

const ghostTileComponentDefinition = {
    controller: GhostTileController,
    template: require('./ghost-tile.component.html').trim(),
};

module.exports = {
    GhostTileController,
    ghostTileComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/ghost-tile.component.js